import { render, staticRenderFns } from "./LoanAndAdvances.vue?vue&type=template&id=713c2fc8&scoped=true&"
import script from "./LoanAndAdvances.vue?vue&type=script&lang=js&"
export * from "./LoanAndAdvances.vue?vue&type=script&lang=js&"
import style0 from "./LoanAndAdvances.vue?vue&type=style&index=0&id=713c2fc8&lang=scss&scoped=true&"
import style1 from "./LoanAndAdvances.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713c2fc8",
  null
  
)

export default component.exports